import { render, staticRenderFns } from "./AdminCoupons.vue?vue&type=template&id=74d49cf8&"
import script from "./AdminCoupons.vue?vue&type=script&lang=js&"
export * from "./AdminCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d49cf8')) {
      api.createRecord('74d49cf8', component.options)
    } else {
      api.reload('74d49cf8', component.options)
    }
    module.hot.accept("./AdminCoupons.vue?vue&type=template&id=74d49cf8&", function () {
      api.rerender('74d49cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCoupons.vue"
export default component.exports